/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StatusWrapper { 
    code?: StatusWrapper.CodeEnum;
}
export namespace StatusWrapper {
    export type CodeEnum = 'OK' | 'Created' | 'Accepted' | 'No Content' | 'Reset Content' | 'Partial Content' | 'Multiple Choices' | 'Moved Permanently' | 'Found' | 'See Other' | 'Not Modified' | 'Use Proxy' | 'Temporary Redirect' | 'Permanent Redirect' | 'Bad Request' | 'Unauthorized' | 'Payment Required' | 'Forbidden' | 'Not Found' | 'Method Not Allowed' | 'Not Acceptable' | 'Proxy Authentication Required' | 'Request Timeout' | 'Conflict' | 'Gone' | 'Length Required' | 'Precondition Failed' | 'Request Entity Too Large' | 'Request-URI Too Long' | 'Unsupported Media Type' | 'Requested Range Not Satisfiable' | 'Expectation Failed' | 'Precondition Required' | 'Too Many Requests' | 'Request Header Fields Too Large' | 'Unavailable For Legal Reasons' | 'Internal Server Error' | 'Not Implemented' | 'Bad Gateway' | 'Service Unavailable' | 'Gateway Timeout' | 'HTTP Version Not Supported' | 'Network Authentication Required';
    export const CodeEnum = {
        Ok: 'OK' as CodeEnum,
        Created: 'Created' as CodeEnum,
        Accepted: 'Accepted' as CodeEnum,
        NoContent: 'No Content' as CodeEnum,
        ResetContent: 'Reset Content' as CodeEnum,
        PartialContent: 'Partial Content' as CodeEnum,
        MultipleChoices: 'Multiple Choices' as CodeEnum,
        MovedPermanently: 'Moved Permanently' as CodeEnum,
        Found: 'Found' as CodeEnum,
        SeeOther: 'See Other' as CodeEnum,
        NotModified: 'Not Modified' as CodeEnum,
        UseProxy: 'Use Proxy' as CodeEnum,
        TemporaryRedirect: 'Temporary Redirect' as CodeEnum,
        PermanentRedirect: 'Permanent Redirect' as CodeEnum,
        BadRequest: 'Bad Request' as CodeEnum,
        Unauthorized: 'Unauthorized' as CodeEnum,
        PaymentRequired: 'Payment Required' as CodeEnum,
        Forbidden: 'Forbidden' as CodeEnum,
        NotFound: 'Not Found' as CodeEnum,
        MethodNotAllowed: 'Method Not Allowed' as CodeEnum,
        NotAcceptable: 'Not Acceptable' as CodeEnum,
        ProxyAuthenticationRequired: 'Proxy Authentication Required' as CodeEnum,
        RequestTimeout: 'Request Timeout' as CodeEnum,
        Conflict: 'Conflict' as CodeEnum,
        Gone: 'Gone' as CodeEnum,
        LengthRequired: 'Length Required' as CodeEnum,
        PreconditionFailed: 'Precondition Failed' as CodeEnum,
        RequestEntityTooLarge: 'Request Entity Too Large' as CodeEnum,
        RequestUriTooLong: 'Request-URI Too Long' as CodeEnum,
        UnsupportedMediaType: 'Unsupported Media Type' as CodeEnum,
        RequestedRangeNotSatisfiable: 'Requested Range Not Satisfiable' as CodeEnum,
        ExpectationFailed: 'Expectation Failed' as CodeEnum,
        PreconditionRequired: 'Precondition Required' as CodeEnum,
        TooManyRequests: 'Too Many Requests' as CodeEnum,
        RequestHeaderFieldsTooLarge: 'Request Header Fields Too Large' as CodeEnum,
        UnavailableForLegalReasons: 'Unavailable For Legal Reasons' as CodeEnum,
        InternalServerError: 'Internal Server Error' as CodeEnum,
        NotImplemented: 'Not Implemented' as CodeEnum,
        BadGateway: 'Bad Gateway' as CodeEnum,
        ServiceUnavailable: 'Service Unavailable' as CodeEnum,
        GatewayTimeout: 'Gateway Timeout' as CodeEnum,
        HttpVersionNotSupported: 'HTTP Version Not Supported' as CodeEnum,
        NetworkAuthenticationRequired: 'Network Authentication Required' as CodeEnum
    };
}


